import { getAssetPath } from '@/utils/helpers';

function setSrc(el, binding) {
  el.setAttribute('src', getAssetPath(binding.value));
}

export default {
  bind(el, binding) {
    setSrc(el, binding);
  },
};



// WEBPACK FOOTER //
// ./src/directives/asset-cdn-src.js